import { router } from '@inertiajs/react'
import { StreamSettings, StreamSettingsData } from '@/components/streams/StreamSettings'
import type { StreamDetail } from '@/types/streams'

interface StreamsSettingsPageProps {
  stream: StreamDetail
}

export default function StreamsSettingsPage({ stream }: StreamsSettingsPageProps) {
  const handleSave = (settings: StreamSettingsData) => {
    router.patch(`/streams/${stream.id}`, {
      stream: {
        name: settings.name,
        description: settings.description,
        ai_context: settings.aiContext,
        // Report generation settings
        character_threshold: settings.characterThreshold,
        report_schedule_type: settings.reportScheduleType,
        report_schedule_day: settings.reportScheduleDay,
        report_schedule_time: settings.reportScheduleTime,
        max_items_per_report: settings.maxItemsPerReport,
        min_items_per_report: settings.minItemsPerReport,
        // Delivery settings
        delivery_schedule_type: settings.deliveryScheduleType,
        delivery_schedule_day: settings.deliveryScheduleDay,
        delivery_schedule_time: settings.deliveryScheduleTime,
        notify_immediately: settings.notifyImmediately,
        report_subscriber_ids: settings.reportSubscriberIds,
        // Trend settings
        trend_lookback_reports: settings.trendLookbackReports,
        trend_lookback_days: settings.trendLookbackDays,
        // Webhook delivery settings
        webhook_enabled: settings.webhookEnabled,
        webhook_url: settings.webhookUrl,
        webhook_secret_token: settings.webhookSecretToken,
        webhook_headers: settings.webhookHeaders,
      },
    }, {
      preserveState: false,
      onSuccess: () => {
        router.visit(`/streams/${stream.id}/settings`)
      },
    })
  }

  const handleCancel = () => {
    router.visit(`/streams/${stream.id}`)
  }

  const handleDelete = () => {
    router.delete(`/streams/${stream.id}`)
  }

  return (
    <StreamSettings
      stream={stream}
      onSave={handleSave}
      onCancel={handleCancel}
      onDelete={handleDelete}
    />
  )
}
